import React, { Component } from "react";

// import UI components
import { Row, Col } from "reactstrap";
import CustomisedModal from "components/Application/CustomisedModal";
import OrderDetailItems from "./OrderDetailItems";

import { getOrderDetailWithLinesByOrderIdRequest } from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import {
  orderStatusList,
  makeOrderDetailSelectField,
} from "store/OrderDetail/selector";
import { createStructuredSelector } from "reselect";
import { formatDateTime, formatOnlyAddress } from "helpers/generalUtils";
import OrderStatus from "./OrderStatus";

class OrderDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getOrderDetailWithLinesByOrderIdRequest(
      this.props.orderDetailData.orderDetailId
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.orderDetailApiResponse &&
      this.props.orderDetailApiResponse !== nextProps.orderDetailApiResponse
    ) {
      if (nextProps.orderDetailApiResponse.isSuccessResponse) {
        this.props.getOrderDetailWithLinesByOrderIdRequest(
          this.props.orderDetailData.orderDetailId
        );
      }
    }
  }

  render() {
    let modalData = null;

    if (this.props.orderDetailRecord) {
      const userAddressJson = this.props.orderDetailRecord.userAddress || {};
      modalData = (
        <React.Fragment>
          <div className="order-customer-info">
            <Row>
              <Col xs="12" lg="6">
                <table className="order-left-info">
                  <tbody>
                    <tr>
                      <td>Order Date:</td>
                      <td>
                        {formatDateTime(this.props.orderDetailRecord.orderDate)}
                      </td>
                    </tr>
                    <tr>
                      <td>Customer Name:</td>
                      <td>{userAddressJson.rcvrName}</td>
                    </tr>
                    <tr>
                      <td>Mobile No:</td>
                      <td>{userAddressJson.rcvrMobileNo}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col xs="12" lg="6">
                <table className="order-left-right">
                  <tbody>
                    <tr>
                      <td>Address:</td>
                      <td>{formatOnlyAddress(userAddressJson)}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>
                        <OrderStatus
                          status={this.props.orderDetailRecord.orderStatus}
                          orderId={this.props.orderDetailRecord.orderDetailId}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Username</td>
                      <td>{this.props.orderDetailRecord.username}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
          <div className="order-customer-info">
            <Row>
              <Col xs="12" lg="6">
                <table className="order-left-info">
                  <tbody>
                    <tr>
                      <td>Total SP:</td>
                      <td>{"₹" + this.props.orderDetailRecord.orderSp}</td>
                    </tr>
                    <tr>
                      <td>Coupon Disc:</td>
                      <td>
                        {"- ₹" + (this.props.orderDetailRecord.couponDisc || 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col xs="12" lg="6">
                <table className="order-left-right">
                  <tbody>
                    <tr>
                      <td>Delivery Chg:</td>
                      <td>
                        {"+ ₹" +
                          (this.props.orderDetailRecord.deliveryCharges || 0)}
                      </td>
                    </tr>
                    <tr>
                      <td>Total Amount</td>
                      <td>₹{this.props.orderDetailRecord.totalOrderAmount}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
          <div className="order-item">
            <OrderDetailItems
              orderItemData={this.props.orderDetailRecord.orderLines || []}
            />
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-xl order-contents"
          isModalOpen={this.props.orderDialog}
          modalTitle={
            this.props.orderDetailRecord && this.props.orderDetailRecord.orderNo
          }
          onModalDismiss={() => this.props.closeModal()}
        >
          {modalData}
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  orderStatusList: orderStatusList(),
  orderDetailRecord: makeOrderDetailSelectField("orderDetailRecord"),
  orderDetailApiResponse: makeOrderDetailSelectField("orderDetailApiResponse"),
});

const withConnect = connect(mapStatetoProps, {
  getOrderDetailWithLinesByOrderIdRequest,
});

export default compose(withConnect, withRouter)(OrderDetailModal);
